// extracted by mini-css-extract-plugin
export var activityContainer = "_le-0";
export var typingIndicatorContainer = "_le-1";
export var typingIndicatorDot = "_le-2";
export var wave = "_le-3";